import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import Map from "../../../components/Map/Map";
import EditLocationModal from "../components/EditLocationModal";
import { UserType } from "../../../utils/enum";
import BaseCheckbox from "../../../components/ui/BaseCheckbox";

const LocationMap = ({
  location,
  isEdit,
  setIsEdit,
  authRole,
  createdById,
  authUserId,
  hasUpdateAccess,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEnableMap, setIsEnableMap] = useState(false);

  const openGooglMapLocation = () => {
    window.open("https://maps.google.com?q=" + location?.latitude + "," + location?.longitude);
  };

  return (
    <BaseCard className="pt-4 pb-6 xl:px-16 px-5 rounded-lg !mb-[0px] h-full" elevation={1}>
      <div className="border-bottom mb-4 flex items-center pb-1">
        <h6 className="text-dark ">
          Location
          {authRole === UserType?.CLIENT && location?.displayName && (
            <span className="text-sm font-light ml-1 ">{`: ${location?.displayName}`}</span>
          )}
        </h6>
        {(authRole === UserType?.CLIENT || authRole === UserType?.CUSTOMER) && hasUpdateAccess && (
          <i
            className="fa-light fa-pencil text-gray-900 ml-2 cursor-pointer"
            onClick={() => {
              setIsModalOpen(true);
              setIsEdit(true);
            }}
          ></i>
        )}
      </div>

      <p className="text-primary cursor-pointer" onClick={openGooglMapLocation}>
        {location?.addressLine1} <span className="italic">({location?.locationType})</span>
      </p>
      <div className="mt-3">
        <BaseCheckbox
          label="Enable Map View"
          checked={isEnableMap}
          onChange={(e) => {
            setIsEnableMap(!isEnableMap);
          }}
        />
      </div>
      {isEnableMap && (
        <div className="mt-3">
          <Map latitude={location?.latitude} longitude={location?.longitude} />
        </div>
      )}
      {isModalOpen && <EditLocationModal open={isModalOpen} close={() => setIsModalOpen(false)} />}
    </BaseCard>
  );
};

export default LocationMap;
